import { fromEvent, Subject } from 'rxjs';
import { WrongBubble } from '../MessageEvent/MessageEventService.types';
/**
 * Defines the event type which is message for window postMessage() Events.
 */
const TYPE = 'message';
/**
 * Receives and propagate events from the window postMessage() API.
 */
export class WindowEventReceiver {
    get messages() {
        return this.subject;
    }
    constructor(windowMessage, eventType = TYPE, currentWindow = window) {
        this.windowMessage = windowMessage;
        this.eventType = eventType;
        this.currentWindow = currentWindow;
        this.subject = new Subject();
        fromEvent(this.currentWindow, this.eventType).subscribe((event) => {
            const response = this.windowMessage.tryParse(event);
            if (response !== WrongBubble) {
                this.subject.next(response);
            }
        });
    }
}
//# sourceMappingURL=WindowEventReceiver.js.map